import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { ProjectNDepartments, TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  attendanceType: '',
  currentLocation: '',
  statuses: [],
  company: '',
  location: '',
  dateFrom: '',
  dateTo: '',
  reason: '',
  deptProject: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  attendanceType: 'eq',
  currentLocation: 'like',
  company: 'eq',
  location: 'eq',
  deptProject: 'in',
  dateFrom: 'ge',
  dateTo: 'le',
  reason: 'in',
  statuses: 'in',
};

export const getFiltersMapper =
  (
    statuses: TypeDict[],
    reasons: TypeDict[],
    deptProjects: ProjectNDepartments[],
    isDatePaired = false
  ): Mapper =>
  (key, value) => {
    if (key === 'attendanceType') {
      return ['leaveTypeID', Number(value)];
    }

    if (key === 'currentLocation') {
      return ['currentLocation', value];
    }

    if (key === 'company') {
      return ['taReqToCompID', Number(value)];
    }

    if (key === 'location') {
      return ['wlId', value];
    }

    if (key === 'deptProject') {
      const deptProjectCodes = (value as string[]).map(
        (item) =>
          deptProjects.find((deptProject) => deptProject.projDeptName === item)!
            .projDeptID
      );
      return ['deptProjID', deptProjectCodes];
    }

    if (key === 'reason') {
      const reasonCodes = (value as string[]).map(
        (item) => reasons.find((reason) => reason.codeDesc === item)!.codeNum
      );
      return ['totDays', reasonCodes];
    }

    if (key === 'dateFrom') {
      return ['startDate', value];
    }

    if (key === 'dateTo') {
      const resultKey = isDatePaired ? 'endDate' : 'startDate';
      return [resultKey, value];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };

export type InitialValuesFilterFormType = typeof initialValuesFilterForm;
